export default "__VITE_ASSET__D6LfyBTU__"